var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m261.688 66h-3.376a.303.303 0 0 0 -.312.296v7.408c0 .165.139.296.312.296h3.376a.303.303 0 0 0 .312-.296v-7.408a.303.303 0 0 0 -.312-.296zm5-8h-3.376a.318.318 0 0 0 -.312.326v15.348c0 .181.139.326.312.326h3.376a.318.318 0 0 0 .312-.326v-15.348a.32.32 0 0 0 -.312-.326zm5 16a.317.317 0 0 0 .312-.325v-10.35a.317.317 0 0 0 -.312-.325h-3.376a.317.317 0 0 0 -.312.325v10.347c0 .18.139.325.312.325h3.376z",
    fill: "#d6dcdf",
    transform: "translate(-258 -58)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 27,
    rx: 2,
    stroke: "#ececec",
    width: 173,
    x: -115.5,
    y: -4.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarGray);
export default __webpack_public_path__ + "static/media/bar-gray.2a2095896a8f4e4a7e5ee2133c61a044.svg";
export { ForwardRef as ReactComponent };